import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import LogicFlow from '@logicflow/core';
import '@logicflow/core/dist/style/index.css';
import { DndPanel, SelectionSelect, Menu, NodeResize, Snapshot } from '@logicflow/extension';
import '@logicflow/extension/lib/style/index.css'

import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import ajax from "@/ajax";
import { useMainStore } from '@/store/index.js'

import '@/assets/css/public-class.scss'
import '@/assets/css/iconfont.css'

import inputFilter from '@/directives/inputFilter'

const pinia = createPinia()
const app = createApp(App)

// 注册 Element Plus
app.use(ElementPlus, { locale: zhCn })

// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 注册 Pinia
app.use(pinia)

// 注册 Router
app.use(router)

// 注册全局指令
app.directive('input-filter', inputFilter)

// LogicFlow 插件
LogicFlow.use(DndPanel);
LogicFlow.use(SelectionSelect);
LogicFlow.use(Menu);
LogicFlow.use(NodeResize);
LogicFlow.use(Snapshot);

// 初始化 Pinia store 并赋值给 ajax
ajax.store = useMainStore()

// 全局属性 (替代 Vue.prototype)
app.config.globalProperties._ajax = ajax
app.config.globalProperties.LogicFlow = LogicFlow
app.config.globalProperties._store = ajax.store

app.config.globalProperties.numberBlur = (event, set) => {
    var k = /\d*\.?\d*%?/
    set.form[set.key] = (event.target.value + "").match(k)[0]
}

app.config.globalProperties.routerReplace = function(name, data) {
    if (!name) {
        return
    }
    this.$router.replace({
        name: name,
        query: data
    });
}

app.config.globalProperties.routerPush = function(name, data) {
    if (!name) {
        return
    }
    this.$router.push({
        name: name,
        query: data
    });
}

app.config.globalProperties.routerResolve = function(name, data) {
    if (!name) {
        return
    }
    let routeUrl = this.$router.resolve({
        path: "/" + name,
        query: data,
    });
    window.open(routeUrl.href, "_blank");
}

app.config.globalProperties.openFun = function(path) {
    if (!path) {
        return
    }
    const link = document.createElement('a');
    link.href = path;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

app.mount('#app')
